import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgEmailAddress = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.0053 2.23548C6.10399 3.00029 2.96252 6.14551 2.19855 10.0464C1.04466 15.9285 5.06449 21.1594 10.5104 21.9485C11.304 22.069 12.0204 21.4366 12.0204 20.6338L12.0204 20.6062C12.0204 19.9491 11.5428 19.4005 10.8999 19.302C7.37854 18.7601 4.67124 15.7063 4.67124 12.0296C4.67124 7.73386 8.37045 4.28555 12.7451 4.7072C16.5667 5.07745 19.3662 8.51662 19.3662 12.3553V13.0299C19.3662 13.9521 18.6173 14.7019 17.6963 14.7019C16.7754 14.7019 16.026 13.9521 16.026 13.0299V8.01607C16.026 7.64673 15.7271 7.34728 15.3577 7.34728L14.0226 7.34743C13.7179 7.34743 13.4715 7.55583 13.3914 7.83504C12.354 7.32781 11.127 7.15122 9.79861 7.62188C8.18092 8.19507 6.9548 9.66373 6.72102 11.3641C6.32513 14.2451 8.54996 16.7077 11.3508 16.7077C12.4546 16.7077 13.4561 16.3093 14.256 15.669C15.2579 16.9757 16.9791 17.7017 18.8231 17.2341C20.751 16.7873 22.0368 14.9003 21.9992 12.9424V12.0698C21.9992 5.84118 16.4093 0.98048 10.0053 2.23548ZM11.3119 14.0737C10.2069 14.0737 9.30808 13.1736 9.30808 12.0678C9.30808 10.9619 10.2069 10.0618 11.3119 10.0618C12.417 10.0618 13.3158 10.9619 13.3158 12.0678C13.3158 13.1736 12.4558 14.0737 11.3119 14.0737Z", fill: props.fill }));
});
export default SvgEmailAddress;
